import { CommandBase } from "../../../common/services/cqs/commandManager";

export class UpdateAtgardAnteckningProdplanCommand extends CommandBase {
    atgardGuid: string;
    anteckning: string;

    constructor(init: (instance: UpdateAtgardAnteckningProdplanCommand) => void) {
        super("UpdateAtgardAnteckningProdplanCommand");
        init(this);
    }
}
